import React, { Component } from 'react';
import './Reports.css';

class Reports extends Component {
  state = {};
  render() {
    if (this.props.children === undefined)
      return <p className="fs-reports-tab-init">Pristup nije dozvoljen.</p>;

    return <div className="fs-reports-tab-content">{this.props.children}</div>;
  }
}

export default Reports;
